import { useMemo } from 'react';
import useProviders from 'Hooks/useProviders';

export default function useCountryProviders(country) {
    const { availableProviders, isLoading } = useProviders();

    const availableProvidersForCountry = useMemo(() => {
        return availableProviders.filter((provider) => !provider.country_code || provider.country_code === country);
    }, [country, availableProviders]);

    return {
        isLoading,
        availableProviders: availableProvidersForCountry,
    };
}
